module.exports = __webpack_public_path__ + "media/images/goals-1-a4b76c3deef50b2a7071e99b4418f885.jpg";